import { render } from "./ContentActividades.vue?vue&type=template&id=5dc7e652&scoped=true&ts=true"
import script from "./ContentActividades.vue?vue&type=script&lang=ts"
export * from "./ContentActividades.vue?vue&type=script&lang=ts"

import "./ContentActividades.vue?vue&type=style&index=0&id=5dc7e652&lang=scss&scoped=true"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc7e652"]])

export default __exports__